import { Collapse, CollapseProps } from "antd"
import { observer } from "mobx-react-lite"
import { FC, useContext, useEffect } from "react"
import { useNavigate } from "react-router-dom"
import { Context } from "../.."
import XPageModal from "../../app/libs/topgun-ui-kit/xmodals/XPageModal"
import { Animator } from "../../app/libs/x-ui-animator/Animator"
import { prevent } from "../../utils"

import styles from "../../styles/Loyalty/LoyaltyStore.module.scss"
import styles2 from "../../styles/Loyalty/LoyaltyStore.module.scss"
import {
  LoyaltyProgramRulesList,
  LOYALTY_RULES_LIST_IDS_RULES_MODAL,
  loyaltyRulesAnimatedItemStyle,
} from "./LoyaltyProgramRulesList"

const RulesModal: FC = () => {

  const { loyaltyStore, store } = useContext(Context)

  const navigate = useNavigate()

  useEffect(() => {
    if (loyaltyStore.isRulesVisible) {
      const animator = new Animator({
        timeline: [
          {point: 400, id: "rrxrule1", styles: {opacity: "1", left: "0px"}},
          {point: 600, id: "rrxrule2", styles: {opacity: "1", left: "0px"}},
          {point: 800, id: "rrrule4", styles: {opacity: "1", left: "0px"}},
          {point: 1000, id: "rrrule5", styles: {opacity: "1", left: "0px"}},
          {point: 1200, id: "rrrule6", styles: {opacity: "1", left: "0px"}},
          {point: 1400, id: "rrrule7", styles: {opacity: "1", left: "0px"}},
          {point: 1600, id: "rrrule8", styles: {opacity: "1", left: "0px"}},
          {point: 1800, id: "rrrule9", styles: {opacity: "1", left: "0px"}},
          // {point: 2200, id: "rule9x9", styles: {opacity: "1", left: "0px"}},
          // {point: 2400, id: "rule10", styles: {opacity: "1", left: "0px"}}
        ]
      })
  
      animator.run()
    } else {
      const animator = new Animator({
        timeline: [
          {point: 0, id: "rrxrule1", styles: {opacity: "0", left: "-200px"}},
          {point: 10, id: "rrxrule2", styles: {opacity: "0", left: "-200px"}},
          {point: 20, id: "rrrule4", styles: {opacity: "0", left: "-200px"}},
          {point: 30, id: "rrrule5", styles: {opacity: "0", left: "-200px"}},
          {point: 40, id: "rrrule6", styles: {opacity: "0", left: "-200px"}},
          {point: 50, id: "rrrule7", styles: {opacity: "0", left: "-200px"}},
          {point: 60, id: "rrrule8", styles: {opacity: "0", left: "-200px"}},
          {point: 70, id: "rrrule9", styles: {opacity: "0", left: "-200px"}},
          // {point: 90, id: "rule9x9", styles: {opacity: "0", left: "-200px"}},
          // {point: 100, id: "rule10", styles: {opacity: "0", left: "-200px"}}
        ]
      })
  
      animator.run()
    }
  }, [loyaltyStore.isRulesVisible])

  return (
    store.userData.source != undefined ? <>
      <XPageModal
        id="rules"
        visible={loyaltyStore.isRulesVisible}
        onClose={() => {
          loyaltyStore.setIsRulesVisible(false)
        }}
        activeZone={false}
        title={<><b className="xmtitle">Правила <strong>ПЛЮСа</strong></b></>}
        content={<>
          <div className={styles.objectively}>

            <LoyaltyProgramRulesList
              ids={LOYALTY_RULES_LIST_IDS_RULES_MODAL}
              itemStyle={loyaltyRulesAnimatedItemStyle}
            />
          </div>
        </>} />
    </> : <></>
  )
}

export default observer(RulesModal)